import {Formik} from 'formik';
import {FormComponent} from './FormComponent';
import {RecordSchema} from './RecordSchema';
import {FormWithButtons} from '@flexinet/ui-components';
import {ApplicationScreenshot, ApplicationScreenshotRecordFormProps} from '../types';
import {stage} from "../../../config/stage";

export const RecordForm = (
    {
        record,
        handleSubmit,
        handleCancel
    }: ApplicationScreenshotRecordFormProps) => {

    const onSubmit = (values: ApplicationScreenshot) => {
        handleSubmit(values);
    };

    let initialValues = {
        viewportWidth: 1920,
        viewportHeight: 1080,
        deviceScaleFactor: 1,
        fullPage: false,
        hideScrollbars: true,
    } as ApplicationScreenshot;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={handleCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
